// Tiny bridge so non-React modules (e.g. the axios interceptor in services/api.ts)
// can raise a toast through the React <ToastProvider>. The provider registers its
// addToast on mount; emitToast is a no-op until then. Keeps api.ts free of React.

type ToastType = 'success' | 'error' | 'info'
type ToastFn = (message: string, type?: ToastType) => void

let handler: ToastFn | null = null

export const registerToastHandler = (fn: ToastFn | null): void => {
  handler = fn
}

export const emitToast = (message: string, type: ToastType = 'info'): void => {
  handler?.(message, type)
}
